// extracted by mini-css-extract-plugin
export default {"connections":"ConnectionsPanel_connections__uQ9k+","connectionSummary":"ConnectionsPanel_connectionSummary__2WdMe","smallButton":"ConnectionsPanel_smallButton__2Tifv"};